import { Fragment } from 'react'
import { Menu, Transition } from '@headlessui/react'
import { ChevronDownIcon } from '@heroicons/react/solid'
import { DropdownInterface } from 'interfaces'

const Dropdown = ({
  name,
  options,
  selected,
  setSelected,
}: DropdownInterface) => {
  return (
    <Menu as="div" className="relative inline-block text-left">
      <Menu.Button className="inline-flex items-center justify-center gap-2 px-4 py-3 bg-white border border-neutral-200 rounded-xl text-sm font-medium text-neutral-700 hover:bg-neutral-50 focus:outline-none focus:ring-2 focus:ring-primary-500 focus:ring-offset-2 transition-all">
        {selected === '' ? (
          name
        ) : (
          <div className="flex items-center gap-2">
            <img
              src={selected.image}
              alt=""
              className="w-6 h-6 rounded-full shadow-sm"
            />
            <span className="font-medium">{selected.currency}</span>
          </div>
        )}
        <ChevronDownIcon className="w-4 h-4 text-neutral-400" />
      </Menu.Button>

      <Transition
        as={Fragment}
        enter="transition ease-out duration-100"
        enterFrom="transform opacity-0 scale-95"
        enterTo="transform opacity-100 scale-100"
        leave="transition ease-in duration-75"
        leaveFrom="transform opacity-100 scale-100"
        leaveTo="transform opacity-0 scale-95"
      >
        <Menu.Items className="absolute left-0 mt-2 w-48 origin-top-left bg-white rounded-xl shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none overflow-hidden z-10">
          <div className="py-1">
            {options.map((item, index) => (
              <Menu.Item key={index}>
                {({ active }) => (
                  <button
                    type="button"
                    className={`w-full flex items-center gap-3 px-4 py-3 text-sm transition-colors ${
                      active ? 'bg-neutral-50 text-neutral-900' : 'text-neutral-700'
                    }`}
                    onClick={() => setSelected(item)}
                  >
                    <img
                      src={item.image}
                      alt=""
                      className="w-6 h-6 rounded-full shadow-sm"
                    />
                    <span className="font-medium">{item.currency}</span>
                  </button>
                )}
              </Menu.Item>
            ))}
          </div>
        </Menu.Items>
      </Transition>
    </Menu>
  )
}

export default Dropdown
